<template>
    <div class="strain-base">
      <router-view></router-view>
    </div>
  </template>

  <script>
  export default {
    name: "strainBase",
  };
  </script>